import { Avatar } from '@cubeyou-team/hx-react-components';
import React, { FC, memo } from 'react';

interface DestinationImageProps {
  src: string;
  alt: string;
}

export const DestinationImage: FC<DestinationImageProps> = memo(
  ({ src, alt }) => {
    if (src?.length === 0)
      return (
        <Avatar hoverEffect="none" initials={alt} size="medium" type="circle" />
      );

    return <img src={src} alt={alt} className="image" />;
  }
);
